import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import routeDefinitions from '../../enum/routeDefinitions';
import { isAvailableToMove } from '../../utils/helpers';


const Hyperlink = ({ children, className, id, isRouterLink, ...rest }) => {
  const location = useLocation();

  if (!isAvailableToMove(location)) {
    if (isRouterLink) {
      return (
        <Link className={className} id={id} to={routeDefinitions.weakPasswordReset}>
          {children}
        </Link>
      );
    }

    return (
      <a className={className} href={routeDefinitions.void} id={id}>
        {children}
      </a>
    );
  }

  if (isRouterLink) {
    return (
      <Link className={className} id={id} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <a className={className} id={id} {...rest}>
      {children}
    </a>
  );
};

Hyperlink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  isRouterLink: PropTypes.bool,
};

Hyperlink.defaultProps = {
  children: null,
  className: '',
  id: '',
  isRouterLink: false,
};

export default Hyperlink;
